import { baseUrl, isSignedIn, getHeaders } from "@services/AuthServices";
import { queryFilter } from "@src/filters/query-filter";

export async function GetSILiAmbEgars(tableFilters) {
    await isSignedIn();

    const query = queryFilter(tableFilters);
    const urlApi = `${baseUrl}/SILiAmb/e-gar${query}`;

    return axios.get(urlApi, getHeaders(true));
}

export async function GetSILiAmbEgar(egarNum, egarCode) {
    await isSignedIn();

    const query = queryFilter({
        egarNumber: egarNum,
        verificationCode: egarCode,
    });
    const urlApi = `${baseUrl}/SILiAmb/e-gar/details${query}`;

    return axios.get(urlApi, getHeaders(true));
}

export async function CorrectEgar(body) {
    await isSignedIn();

    const urlApi = `${baseUrl}/SILiAmb/e-gar/correct`;

    return axios.put(urlApi, body, getHeaders(true));
}

export async function CreateEgar(body) {
    await isSignedIn();

    const urlApi = `${baseUrl}/SILiAmb/e-gar/issue`;

    return axios.post(urlApi, body, getHeaders(true));
}

export async function AnularEgar(body) {
    await isSignedIn();

    const urlApi = `${baseUrl}/SILiAmb/e-gar/cancel`;

    return axios.put(urlApi, body, getHeaders(true));
}

export async function RejectEgar(body) {
    await isSignedIn();

    const urlApi = `${baseUrl}/SILiAmb/e-gar/reject`;

    return axios.put(urlApi, body, getHeaders(true));
}

export async function AssociateEgar(body) {
    await isSignedIn();

    const urlApi = `${baseUrl}/SILiAmb/e-gar/associate`;

    return axios.put(urlApi, body, getHeaders(true));
}

export async function AcceptEgar(body) {
    await isSignedIn();

    const urlApi = `${baseUrl}/SILiAmb/e-gar/accept`;

    return axios.put(urlApi, body, getHeaders(true));
}

export async function AcceptCorrectionEgar(body) {
    await isSignedIn();

    const urlApi = `${baseUrl}/SILiAmb/e-gar/confirm-correction`;

    return axios.put(urlApi, body, getHeaders(true));
}

export async function RejectCorrectionEgar(body) {
    await isSignedIn();

    const urlApi = `${baseUrl}/SILiAmb/e-gar/deny-correction`;

    return axios.put(urlApi, body, getHeaders(true));
}

export async function SendEmailEgar(body) {
    await isSignedIn();

    const urlApi = `${baseUrl}/SILiAmb/e-gar/send-email`;

    return axios.post(urlApi, body, getHeaders(true));
}

export async function AuthorizeEgar(body) {
    await isSignedIn();

    const urlApi = `${baseUrl}/SILiAmb/e-gar/authorize`;

    return axios.post(urlApi, body, getHeaders(true));
}
